import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["value", "inputmode", "aria-invalid", "title"]

import { computed, ref, watch, watchEffect } from "vue";
import type { PublicEventParamType } from "./EntityPresetEditor/publicEventPresets";
import { getPublicEventParameterDefault } from "./EntityPresetEditor/publicEventPresets";
import { getTypedValueError, isTypedValueDraft } from "./typedValueInput";
import StudioSelectField from "./StudioSelectField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TypedValueInput',
  props: {
    modelValue: { default: "" },
    valueType: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const input = ref<HTMLInputElement>();
const composing = ref(false);
const checked = ref(false);
const acceptedValue = ref(props.modelValue);
watch(() => props.modelValue, value => { acceptedValue.value = value; }, { flush: "sync" });
const error = computed(() => checked.value || props.valueType === "Bool" ? getTypedValueError(props.valueType, acceptedValue.value) : "");
watchEffect(() => { input.value?.setCustomValidity?.(error.value); }, { flush: "post" });

function updateValue(event: Event) {
  if (composing.value || (event as InputEvent).isComposing) return;
  const element = event.target as HTMLInputElement;
  if (!isTypedValueDraft(props.valueType, element.value)) {
    element.value = acceptedValue.value;
    return;
  }
  if (element.value !== acceptedValue.value) {
    acceptedValue.value = element.value;
    emit("update:modelValue", element.value);
  }
}

function selectBoolean(value: string) {
  acceptedValue.value = value;
  checked.value = true;
  emit("update:modelValue", value);
}
watch(() => props.valueType === "Bool" && props.modelValue === "", (empty: boolean) => {
  if (empty) selectBoolean(getPublicEventParameterDefault("Bool"));
}, { immediate: true });

function beforeInput(event: InputEvent) {
  if (props.valueType === "String" || composing.value || event.isComposing || !event.cancelable
      || !event.inputType.startsWith("insert") || event.data === null) return;
  const element = event.target as HTMLInputElement;
  if (element.selectionStart === null || element.selectionEnd === null) return;
  const next = element.value.slice(0, element.selectionStart) + event.data + element.value.slice(element.selectionEnd);
  if (!isTypedValueDraft(props.valueType, next)) event.preventDefault();
}

function compositionEnd(event: CompositionEvent) {
  composing.value = false;
  updateValue(event);
}

return (_ctx: any,_cache: any) => {
  return (__props.valueType === 'Bool')
    ? (_openBlock(), _createBlock(StudioSelectField, {
        key: 0,
        "model-value": __props.modelValue || _unref(getPublicEventParameterDefault)('Bool'),
        "aria-invalid": error.value ? 'true' : undefined,
        title: error.value || undefined,
        "onUpdate:modelValue": selectBoolean
      }, {
        default: _withCtx(() => [
          (__props.modelValue !== '' && __props.modelValue !== 'False' && __props.modelValue !== 'True')
            ? (_openBlock(), _createElementBlock("option", {
                key: 0,
                value: __props.modelValue,
                disabled: ""
              }, _toDisplayString(__props.modelValue) + "（当前值，请重新选择）", 9, _hoisted_1))
            : _createCommentVNode("", true),
          _cache[3] || (_cache[3] = _createElementVNode("option", { value: "False" }, "否", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("option", { value: "True" }, "是", -1))
        ]),
        _: 1
      }, 8, ["model-value", "aria-invalid", "title"]))
    : (_openBlock(), _createElementBlock("input", {
        key: 1,
        ref_key: "input",
        ref: input,
        value: __props.modelValue,
        type: "text",
        inputmode: __props.valueType === 'String' ? 'text' : __props.valueType === 'Float' ? 'decimal' : 'numeric',
        "aria-invalid": error.value ? 'true' : undefined,
        title: error.value || undefined,
        onBeforeinput: beforeInput,
        onInput: updateValue,
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (checked.value = false)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (checked.value = true)),
        onCompositionstart: _cache[2] || (_cache[2] = ($event: any) => (composing.value = true)),
        onCompositionend: compositionEnd
      }, null, 40, _hoisted_2))
}
}

})